import { render } from "./NaveProd.vue?vue&type=template&id=0d24b59c&scoped=true"
import script from "./NaveProd.vue?vue&type=script&lang=js"
export * from "./NaveProd.vue?vue&type=script&lang=js"

import "./NaveProd.vue?vue&type=style&index=0&id=0d24b59c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d24b59c"]])

export default __exports__